export class URLUtils {
    static login = `/admin/login`;
    static forgotPwd = `/admin/forgot-password`
    static confirm = `/admin/forgot-password/confirm`
    static getMatter = `/v3/dashboard/matter`
    static getExternalMatters = '/v3/dashboard/external-matters'
    static getGeneralExternalMatter = '/v3/sharedgeneral'
    static getLegalExternalMatter = '/v3/sharedlegal'
    static updateDocwithMatters = '/v3/update'
    static postDocumentsClient = '/v3/document/upload'
    static getLegalMatter = `/matter/legalnew`
     static country = '/countries'
    static getAppt = '/admin/appointments'
    static getApptSummary = '/admin/appointments/summary'
    static getApptFilters = '/admin/appointments/filters'
    static ApptNotes = '/admin/appointments/notes'
    static apptNotes(appointmentId: any) {
        return `/admin/appointments/${appointmentId}/notes`;
    }
    static apptSettlement(appointmentId: any) {
        return `/admin/appointments/${appointmentId}`;
    }
    constructor() {
        // Constructor logic if needed
    }
    static getEngagementTrend = '/analytics/trend'
    static getLocationDistribution = '/admin/dashboard/location-distribution';
    static getPracticeDistribution  = '/admin/dashboard/distribution';
    static getCityList              = '/admin/dashboard/city-list';
    static getMattersByClient(args: any) {
        return `/v3/matter/all/${args.id}`
    }
    static deleteLegalMatter(Id: any) {
        return `/matter/legal/delete/` + Id;
    }
    static getCountries = `/countries`
    static relationshipEntityDetails(args: any) {
        return `/v2/relationship/entity/${args.entityId}`
    }
    static relationshipSearchEntities = `/v2/relationship/search/entity`
    static getAllMatters =`/v3/matter/all`
    static getGrouplist = `/v3/documents/groupslist`
    static getAllExternalMatters = '/v3/sharedmatter/all'

    static getGeneralMatter = `/matter/generalnew`
    static getGenMatterEventList = '/v3/matter/general'
    static createGeneralMatter = '/matter/general/create'
    static updateMatterAccess(matterid:any, id: any) {
        return `/v3/matter/groups/${matterid}/${id}`
    }
    static updateGeneralMatter(Id: any) {
        return `/matter/general/update/` + Id;
    }
    static deleteGeneralMatter(Id: any) {
        return `/matter/general/delete/` + Id;
    }
    static updateLegalAcls(Id: any) {
        return `/matter/legal/` + Id + `/acls`
    }
    static getGeneralMatterInfoDetails(Id: any) {
        return `/v3/matter/general/` + Id;
    }
     static createLegalMatter = '/matter/legal/create'
    // Removed duplicate declaration of getAllRelationship
    static getCountry='/countries'
    static matterIndiviuals = '/v3/relationship/temp-invite/consumer'
    static updateGeneralAcls(Id: any) {
        return `/matter/general/` + Id + `/acls`
    }
    static getGeneralHistory(args: any) {
        return `/matter/general/` + args.id + `/history/` + args.offset;
    }
    static updateGeneralTags(args: any) {
        return `/matter/general/${args.id}/tags`
    }
    static getClientPdfDocuments = '/v3/pdfdocuments/client';
    static viewDocuments(args: any) {
        return `/v3/document/${args.id}/view`
    }
     static getFilterTypeAttachements = `/matter/attachments`
    static legalHistoryDocumentsUpdate(id: any) {
        return `/matter/legal/` + id + `/documents/update`
    }
    static decryptFile= `/v3/decrypt`
    static checkMatterUnique = '/matter/check/unique'
    static legalHistoryDocuments(id: any) {
        return `/matter/legal/` + id + `/documents`
    }
    static updateEventNotes(id: any) {
        return `/event/notes/${id}`;
    }
    static updateLegalMatter(Id: any) {
        return `/matter/legal/update/` + Id;
    }
    static getLegalMatterviewDetail(args: any) {
        return `/matter/legal/` + args.id + `/history/` + args.offset;
    }
    static updateLegalHistoryMembers(id: any) {
        return `/matter/legal/` + id + `/members/update`
    }
    static updateCorpNotes(id: any) {
        return `/v3/notes/${id}`;
    }
    static getLegalHistoryMembers(id: any) {
        return `/matter/legal/` + id + `/members`
    }
    static getLegalMatterInfoDetails(Id: any) {
        return `/v3/matter/legal/` + Id;
    }
    static deleteCorpNotes(id: any) {
        return `/v3/notes/` + id;
    }

    static getGeneralMatterDetails(args: any) {
        return `/matter/general/view/${args.id}`
    }
    static generalHistoryDocuments(id: any) {
        return `/matter/general/` + id + `/documents`
    }
    static generalHistoryDocumentsUpdate(id: any) {
        return `/matter/general/` + id + `/documents/update`
    }
    static getGeneralHistoryMembers(id: any) {
        return `/matter/general/` + id + `/members`
    }
    static updateGeneralHistoryMembers(args: any) {
        return `/matter/general/${args.id}/members/update`
    }

    static getClientMatter(args: any) {
        return `/v2/matter/all/${args.id}`
    }

    static leadNotes(uid: string, leadId: string): string {
        return `/users/${uid}/leads/${leadId}/notes`;
      }

      static queryNotes(uid: string, id: any): string {
        return `/enquiries/${uid}?id=${id}`;
      }
    
    static addLeadNotes(uid: string, leadId: string): string {
        return `/users/${uid}/leads/${leadId}/notes`;
    }

    static addQueryNotes(uid: string, id:any): string {
        return `/enquiries/${uid}?id=${id}`;
    }

    static getLeadList(uid: any) {
        return `/addlawyers/${uid}`;
    }
    
    static addLeads(uid: any) {
        return `/v3/addlawyers/${uid}`;
    }

    static deleteLeads(id:any) {
        return `/v3/addlawyers?id=${id}`;
    }

    static deleteQuery(id:any, uid:any) {
        return `/enquiries/${uid}?id=${id}`;
    }

    static updateLeads(id:any) {
        return `/v3/addlawyers?id=${id}`;
       
    }

    static updateQuery(id:any, uid:any) {
         return `/enquiries/${uid}?id=${id}`
    }

    static getQueryList() {
        return `/v3/complaints`;
    }
    static getDepartment(uid:any) {
        return `/departments/${uid}`;
    }

    static leadslawyers(){
        return `/v3/addlawyers`;
    }

    static updateStatus(id:any) {
        return `/v3/addlawyers?id=${id}`;
    }

    static updateQueryStatus(id:any, uid:any) {
        return `/enquiries/${uid}?id=${id}`;
    }

    static csvtoleads(uid:any){
        return `/csvtoleads/${uid}`;
    }

    static csvFileKey(filekey:any){
        return `/upload/status?file_key=${filekey}`;
    }

    static getDocuments(enquiryid:any){
        return `/v3/documents/${enquiryid}`;
    }

    static viewDocument(docid:any){
        return `/v3/document/${docid}/view`;
    }

    static genLink(uid:any, id:any){
        return `/generate-link/${uid}?enquiry_id=${id}`;
    }

    static downloadDocument(docid:any){
        return `/v3/document/${docid}/download`;
    }

    static getsharedLegal() {
        return `/v3/sharedlegal`;
    }

    static getsharedGeneral() {
        return `/v3/sharedgeneral`;
    }

    static attachDocumenttoMatter() {
        return `/v3/matter/extdocuments/updates`;
    }
    static getLoginTrend = '/login/trend';
    static getProfileCompletionData = '/profile-completion/trend'
    static getOnboardingTrend = '/onboard/trend';
    static getDownloadTrend = '/download/trend'

     // Relationships
    static getAllRelationship = '/v3/client/all/list';
    static getRelationship = '/v2/relationship/client/list';
    static getChatRelationship = '/v2/relationship';
    static relationshipTemporary='/v3/tempclient';
    static getcorporateRelationship ='/v3/corporate';

    static getNotify(filter: any) {
        return `/relationship/${filter.id}/users/notify`
        //return `/v3/relationship/client/${filter.id}/notify/users`
    }
    static ConvertTempClients = '/v3/convert-temp-clients';

    static getRelationshipFiltered(filter: string) {
        return `/v2/relationship/${filter}`
    }

    static updateRelationshipMember(filter: string) {
        return `/v2/relationship/${filter}/members`
    }

    static shareRelationshipDocuments(args: any) {
        return `/v2/relationship/${args.id}/docs/share`
    }
    static shareRelationshipDocumentsCorp =`/v3/share`

    static shareInvoiceDocuments(args: any) {
        return `/v2/relationship/${args}/docs/share`
    }

    static sharedDocuments(args: any) {
        return `/v2/relationship/${args.id}/docs/shared/byme`
    }

    static relationshipViewDoc(args: any) {
        return `/v2/relationship/${args.relId}/${args.docid}/view`
    }

    static relationshipViewDocCorp(args: any) {
        return `/v3/relationship/${args.relId}/${args.docid}/view`
    }

    static relationshipDownloadDoc(args: any) {
        return `/v2/relationship/${args.relId}/${args.docid}/download`
    }

    static relationshipCopyDoc(args: any) {
        return `/v2/relationship/${args.relId}/${args.docid}/copy`
    }

    static relationshipExchangeInfoProfile(args: any) {
        return `/v2/relationship/${args.id}/profile`
    }
    static relationshipExchangeInfoProfileCorp(args: any) {
        return `/v3/profile/${args.id}`
    }
    static relationshipDocsSharedwithus(args: any) {
        return `/v2/relationship/${args.id}/docs/shared/withme`
    }
    static relationshipDocsSharedbyus(args: any) {
        return `/v2/relationship/${args.id}/docs/shared/byme`
    }
    static relationshipDocsSharedwithusCorp(args: any) {
        return `/v3/share/${args.id}/withme`
    }
    static relationshipDocsSharedbyusCorp(args: any) {
        return `/v3/share/${args.id}/byme`
    }

    // Relationship Search 
    static relationshipSearchConsumer = '/v2/relationship/search/consumer'
    static relationshipSearchCorporate = `/v2/relationship/search/corporate`
    static relationshipSearchLauditor = '/v2/relationship/search/lauditor'
    static relationshipAllList(product: any) {
        return `/v2/relationship/search/${product}`
    }

    // Relationship Requests
    static relationshipEntityRequest = `/v2/relationship/request/entity`
    static relationshipConsumerRequest = `/v2/relationship/request/consumer`
    static relationshipCorporateRequest = `/v3/corporate`
     static getFilteredDocuments = `/v3/document/filter`

    // Relationship Invites
    static relationshipInviteEntity = `/v2/relationship/invite/entity`
    static relationshipInviteConsumer = `/v3/marketplace`
    
    static relationshipMarketplace = `/v3/marketplace`
    static relMarketplaceGrpUpdate(args: any) {
        return `/v3/marketplace/${args.id}`
    }
    static editInviteRelationshipEntity(args: any) {
        return `/v2/relationship/${args.relid}/edit`
    }

     //Relationship Enhancement
    static updateRelationshipAccess(relid:any, id: any) {
        return `/v3/relationship/groups/${relid}/${id}`
    }

    static relationshipViewProfile(args: any) {
        return `/v2/relationship/${args.id}/profile`
    }

    static addRelationshipReminder(args: any) {
        return `/v2/relationship/${args.id}/reminders`
    }
    static relationshipGroupAcls(args: any) {
        return `/v2/relationship/${args.id}/acls`
        //return `/v3/acl/${args.id}/update`
    }
    static relationshipGroupAclsCorp(args: any) {
        //return `/v2/relationship/${args.id}/acls`
        return `/v3/acl/${args.id}/update`
    }
    static acceptRelationship(args: any) {
        return `/v2/relationship/${args.id}/accept`
    }
    static acceptRelationshipCorp(args: any) {
        return `/v3/corporate/${args.id}/accept`
    }

    static terminateRelationship(args: any) {
        return `/v2/relationship/${args.id}/terminate/request`
    }

    static getProfessionalDocs(args: any) {
        return `/docs/professional/${args.userid}/user`
    }

    // Groups 
    static getGroups = `/admin/groups`
    static addGroup = `/admin/group`
    static getUserGroups = `/admin/groups/user`
    static updateGroup(args: any) {
        return `/admin/v3/group/${args.id}`
    }
    static deleteGroup(args: any) {
        return `/admin/v3/group/${args.id}/${args.newid}`
    }
    static moveGroups(args: any) {
        return `/admin/v3/members/${args.id}/move`
    }
    static groupActivityLog = `/professional/v3/auditlogs`

    // Users
    static getMembersList = `/admin/members`
    static getMembers = `/admin/members`
     static getGroupsAttach = `/admin/groups/attach`
    static getGroupsAttachWithMember(memberId: string) {
        return `/admin/groups/attach?member_id=${memberId}`;
    }
    static updateMemberGroups(memberId: string) {
        return `/admin/members/${memberId}/update/groups`;
    }
    static getGroupHeads = `/admin/groupHeads`
    static addMember = `/admin/members/create`
    static resetMemberPassword = `/admin/members/resetpwd`
    static getGroupAuditLogs(args: any) {
        return `/admin/v3/auditlogs/${args.id}`
    }
    static getGroupResources(args: any) {
        return `/admin/v3/group/resources/counts/${args.id}`
    }
    static updateMember(args: any) {
        return `/admin/members/${args.id}/update/groups`
    }
    static updateMemberinfo(args: any) {
        return `/admin/members/${args.id}/update`
    }
    static deleteMember(args: any) {
        return `/admin/members/${args}/deactivate`
    }
    static disableMember(args: any) {
        return `/admin/members/${args.id}/disable`
    }
    static makeMemberAdmin(args: any) {
        return `/admin/members/${args.id}/admin`
    }
    static getChatUsers = `/chatusers`
    static getChatList = '/v3/chatlist'

    //Paginations
    static searchLeads(args: any) {
        return `/v3/addlawyers?search=${args}`
    }
    static searchQuery(args: any) {
        return `/v3/complaints?search=${args}`
    }

    //Limitations
    static getLeadLimit(args: any) {
        return `/v3/addlawyers?limit=${args}`
    }
    static getNCLeadLimit(args: any,next:any) {
        return `/v3/addlawyers?limit=${args}&after=${next}`
    }

    static getQueryLimit(args: any) {
        return `/v3/complaints?limit=${args}`
    }
    static getNCQueryLimit(args: any,next:any) {
        return `/v3/complaints?limit=${args}&after=${next}`
    }

    //Documents
    static postDocumentsFirm = '/v3/documents/firm'
    static MergePdfDocumentsClient = '/v3/mergepdf'
    static tempClientPost = '/v3/tempclient'
    static inviteConsumer = '/v2/relationship/invite/consumer'
    static inviteEntity = '/v2/relationship/invite/entity'
    
    static editMergepdfFile(args: any) {
        return `/v3/mergepdf/${args.id}`
    }
    static createMerge = `/docs/mergepdf/add`

    static addPagination = `/v3/mergepdf/paginate/docs`
    static addPaginationQueue = `/v3/mergepdf/paginate/queue`
    static viewMergepdfFile(args: any) {
        return `/docs/mergepdf/${args.id}/view`
    }

    static downloadMergepdfFile(args: any) {
        return `/v3/mergepdf/${args.id}/download`
    }

    static getMergedDocs = `/docs/mergepdf`

    static updateMergedpdfTags(args: any) {
        return `/v3/mergepdf/${args.id}/tags`
    }
    static deleteMergedpdf(args: any) {
        return `/v3/mergepdf/${args.id}`
    }

    static addShortText = `/v3/mergepdf/shortext/docs`
    static addShortTextqueue = `/v3/mergepdf/shortext/queue`
    static deletePages = `/v3/mergepdf/delpages/docs`
    static deletePagesQueue = `/v3/mergepdf/delpages/queue`
    static addWatermaek = '/v3/mergepdf/watermark/docs'
    static addWatermarkQueue = '/v3/mergepdf/watermark/queue'

    static getCalenderExternal = `/v3/corporate/list`

    //Delete Approval Doc
    static deleteApprovalGetLists=`/docs/deleted/list`
    static deleteApprovalView = `/docs/deleted/view`
    static deleteApprovalDelete =`/docs/deleted/delete`
    static deleteApprovalRestore =`/docs/deleted/restore`

     static NextPageMessages(args: any) {
        return `/api/v1/gmail/messages/${args.token}?rows=${args.rows}&nextpagetoken=${args.nextpagetoken}`
    }
    static searchMessages(args: any) {
        return `/api/v1/${args.type}/messages/${args.token}?rows=${args.rows}&subject=${args.search}&search=${args.search}&labelid=${args.labelid}`
    }
    static messagesCount(args: any) {
        return `/api/v1/${args.type}/label/${args.token}?labelid=${args.labelid}`
    }
    static MessageDetails(args: any) {
        return `/api/v1/gmail/message/detail/${args.token}/${args.msgid}`
    }
    static MessageDocUpload(args: any) {
        return `/api/v1/gmail/message/attachment/upload/${args.token}/${args.msgid }?partid=${args.partid}`
    }
    static sendMessage(args: any) {
        return `/api/v1/${args.type}/sendmail/attach/documents/${args.token}`
    }
    static sendOutlookMessage(args: any) {
        return `/api/v1/outlook/sendmail/${args.token}/${args.docid}`
    }
    static viewMergedDocuments(args: any) {
        return `/v3/mergepdf/${args.id}/view`
    }
    static DownloadDocuments(args: any) {
        return `/v3/document/${args.id}/view`
    }
    static editDocuments(args: any) {
        return `/v3/document/${args.id}`
    }
    static editTags(args: any) {
        return `/v3/document/tags/${args.id}`
    }
    static deleteDocument = '/v3/document/delete'
    static encryptDoc(id:any){
        return `/v3/document/encrypt/${id}`
    }
    static decryptDoc(id:any) {
        return `/v3/document/decrypt/${id}`
    }

      //Documents
    static getFirmDocuments = `/v3/documents/firm`;
    static getClientDocuments = `/v3/documents/client`;
    static filterMergeDoc = '/v3/mergepdf/filter';
    static getfrmPdfDocuments = '/v3/pdfdocuments/firm';
    static getMergedDocuments = `/v3/mergepdf`;
    static getFilterDocuments = `/docs/docsearch`
    static getCalenderDocuments = `/docs/professional/admin/user`
    static getGeneralDocuments(args: any) {
        return `/docs/professional/${args.userid}/user`
    }

    static updateGeneralDocument(args: any) {
        return `/docs/professional/${args.id}/update`
    }
    static uploadProfDocument = `/docs/professional/add`

    static viewGeneralDocument(args: any) {
        return `/docs/professional/${args.id}/view`
    }

    static downloadGeneralDocument(args: any) {
        return `/v3/document/${args.id}/download`
    }

    static downloadInvoiceDocument(args: any) {
        return `/v3/document/${args}/download`
    }

    static deleteGeneralDocument = `/docs/professional/delete`

    static shareDocumentsToIndividual(args: any) {
        return `/clients/${args.id}/consumer/bizdocs/web`
    }

    static updateTags(args: any) {
        return `/docs/professional/${args.id}/tags`
    }

    // Notifications
    static getNotifications = `/admin/notifications`;
    static markNotificationsRead = `/admin/notifications`;
    static deleteNotifications = `/admin/notifications`;

    // Audit Trails
    static getAuditTrails = `/admin/audit`;

    // Client history (LexiZ client detail screen)
    static clientHistorySummary(clientId: any) {
        return `/admin/clients/${clientId}/history/summary`;
    }

    static clientHistoryAppointments(clientId: any) {
        return `/admin/clients/${clientId}/history/appointments`;
    }

    static clientHistoryAppointmentDetail(clientId: any, appointmentId: any) {
        return `/admin/clients/${clientId}/history/appointments/${appointmentId}`;
    }

    static clientHistoryPayments(clientId: any) {
        return `/admin/clients/${clientId}/history/payments`;
    }

    static clientHistoryPaymentDetail(clientId: any, paymentId: any) {
        return `/admin/clients/${clientId}/history/payments/${paymentId}`;
    }

    static clientHistoryRefunds(clientId: any) {
        return `/admin/clients/${clientId}/history/refunds`;
    }

    static clientHistoryRefundDetail(clientId: any, refundId: any) {
        return `/admin/clients/${clientId}/history/refunds/${refundId}`;
    }

    static clientHistoryActivity(clientId: any) {
        return `/admin/clients/${clientId}/history/activity`;
    }

    // Lawyer history (LexiZ lawyer detail screen)
    static lawyerHistorySummary(lawyerId: any) {
        return `/admin/lawyers/${lawyerId}/history/summary`;
    }

    static lawyerHistoryAppointments(lawyerId: any) {
        return `/admin/lawyers/${lawyerId}/history/appointments`;
    }

    static lawyerHistoryAppointmentDetail(lawyerId: any, appointmentId: any) {
        return `/admin/lawyers/${lawyerId}/history/appointments/${appointmentId}`;
    }

    static lawyerHistorySettlements(lawyerId: any) {
        return `/admin/lawyers/${lawyerId}/history/settlements`;
    }

    static lawyerHistorySettlementDetail(lawyerId: any, payoutId: any) {
        return `/admin/lawyers/${lawyerId}/history/settlements/${payoutId}`;
    }

    static lawyerHistoryEarnings(lawyerId: any) {
        return `/admin/lawyers/${lawyerId}/history/earnings`;
    }

    static lawyerHistoryActivity(lawyerId: any) {
        return `/admin/lawyers/${lawyerId}/history/activity`;
    }

}